import { useState } from 'react';

import { useAppDispatch, useAppSelector } from '@/Application/Hooks/Redux';
import { TPaymentMethodId } from '@/modules/perseo-billing/components/accordion/interfaces';
import { useEnableAccordion } from '@/modules/perseo-billing/components/accordion/use-enable-accordion';
import { useGtmBillingProduct } from '@/modules/perseo-billing/hooks/use-gtm-billing';
import {
  setActiveAccordion,
  setIsInvoiceAndGuestModalOpen,
  setIsNeedInvoiceModalOpen
} from '@/modules/perseo-billing/store/slices/billing';
import {
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';
import { isDeviceKiosco } from '@/modules/perseo-billing/utils';
import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';
import { isWeddingFlow } from '@/modules/shared/utils/isWeddingFlow';

import { InvoiceOrGiftCardModal } from './invoice-or-gift-card-modal.component';

const isWedding = isWeddingFlow();
const isKiosco = isDeviceKiosco();

interface NeedInvoiceProps {
  isForeignDocument?: boolean;
}

export const NeedInvoice = ({ isForeignDocument }: NeedInvoiceProps) => {
  const dispatch = useAppDispatch();
  const { linkNeedInvoiceGtm } = useGtmBillingProduct();
  const data = useAppSelector((state) => state?.cart?.data);
  const { getPaymentMethodEnabled } = useEnableAccordion();
  const [isDisabledInvoiceModalOpen, setIsDisabledInvoiceModalOpen] =
    useState(false);

  const hasAddress = data?.billingAddress?.isInvoice;

  // Determine if customer has foreign document
  const documentType = data?.shippingAddress?.documentType;
  const hasForeignDocument =
    isForeignDocument !== undefined
      ? isForeignDocument
      : documentType === IdentificationDocumentTypes.DNI;

  if (hasAddress) return <></>;
  if (isWedding) return <></>;
  if (hasForeignDocument) return <></>; // Hide invoice option for foreign documents

  const isAvailableInvoice = getPaymentMethodEnabled(TPaymentMethodId.INVOICE);
  const isGuest = !!data?.anonymousId;

  const onClickHandler = () => {
    linkNeedInvoiceGtm();
    dispatch(setActiveAccordion(null));
    if (!isAvailableInvoice) return setIsDisabledInvoiceModalOpen(true);
    if (isKiosco) return dispatch(setIsNeedInvoiceModalOpen(true));
    if (isGuest) return dispatch(setIsInvoiceAndGuestModalOpen(true));

    return dispatch(setIsNeedInvoiceModalOpen(true));
  };

  return (
    <>
      <button
        className="co-flex co-gap-8px co-items-center co-cursor-pointer"
        onClick={onClickHandler}
      >
        <Icon
          className="co-fill-current co-text-primary-main"
          icon={'InvoiceIcon'}
          width={24}
          height={24}
        />
        <Typography
          color="primary"
          weight="medium"
          decoration="underline"
          className="co-inline-block"
        >
          {'¿Necesitas factura?'}
        </Typography>
      </button>
      <InvoiceOrGiftCardModal
        isOpen={isDisabledInvoiceModalOpen}
        setIsDisabledInvoiceModalOpen={setIsDisabledInvoiceModalOpen}
      />
    </>
  );
};
